import _useMount from 'react-use/esm/useMount';
import {notify} from '@gemcook/notification';

import {UseMount} from './types';
import resources from '@resources';
import utils from '@utils';

export const useMount: UseMount = (props, actions, setIsModal) => {
  _useMount(async () => {
    const id = utils.pathParams.getUserId(props.location.pathname);

    try {
      utils.scroll.top();
      props.actions.users.clearUserDetail();

      if (
        props.history.action !== 'PUSH' ||
        props.users.pagination.data.active
      ) {
        await actions.users.getOneUser(id);
        return;
      }
      props.actions.users.getUserDetail(id, props.users.pagination.data.active);
    } catch (error) {
      if (error.response.data.message === 'user not found') {
        setIsModal(true);
      } else {
        notify(resources.users.getErrorMessage(error.message, 'user'), 'error');
      }
    }
  });
};
